import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import WaveLayerSpinSpeedListItem from "./WaveLayerSpinSpeedListItem";
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import WaveLayerSpinAccelerationListItem from './WaveLayerSpinAccelerationListItem';
import { VISUALIZER_SHAPE } from '../../../../Preview/PreviewDisplayConstants';

const WaveLayerSpinListItem = ({ enabled, index, visualizerShape, updateWaveLayerSpinSettings }) => {
    const handleToggleEnabled = useCallback(value => {
        updateWaveLayerSpinSettings(index, "enabled", value)
    }, [index])

    if (visualizerShape !== VISUALIZER_SHAPE.CIRCLE) {
        return null;
    }

    return (
        <CollapsibleSwitchListItem
            checked={enabled}
            text='Spin'
            onChange={handleToggleEnabled}
            dense={false}
        >
            <List dense disablePadding>
                <WaveLayerSpinSpeedListItem index={index} />
                <WaveLayerSpinAccelerationListItem index={index} />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, { index }) => {
    const { shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    const spinSettings = state.createPreview.present.videoSettings.visualizer.waveCircles[index]?.customOptions?.spinSettings;
    return { enabled: spinSettings?.enabled ?? false, visualizerShape };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerSpinSettings: (index, key, value) => dispatch(createActions.updateWaveLayerSpinSettings(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerSpinListItem);